import { render, staticRenderFns } from "./DadosPerfis.vue?vue&type=template&id=78fb7878"
import script from "./DadosPerfis.vue?vue&type=script&lang=js"
export * from "./DadosPerfis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports